import { Navigate, Route, Routes } from 'react-router-dom'

import { BannersProvider } from '@src/app/banner'
import Banners from '@src/app/banner/Banners'
import CustomBanner from '@src/app/banner/CustomBanner/CustomBanner'
import OutageBanner from '@src/app/banner/OutageBanner'
import { useStorePartnerStackKey } from '@src/app/onboarding/partnerStack'
import { UniversalLogin, UniversalLoginSignup } from '@src/app/universal-login'
import UniversalLoginCouponRoute from '@src/app/universal-login/UniversalLoginCouponRoute'

import UniversalLoginAuthorize from './UniversalLoginAuthorize'
import UniversalLoginReauthenticateInfoModal from './UniversalLoginReauthenticateInfoModal'
import * as styles from './UniversalLoginRoute.css'
import UniversalLoginSso from './UniversalLoginSso'

import DesktopDraggableArea from '@odyssey/components/DesktopDraggableArea/DesktopDraggableArea'

function UniversalLoginRoute() {
  useStorePartnerStackKey()

  return (
    <>
      <BannersProvider>
        <Banners>
          <CustomBanner />
          <OutageBanner />
        </Banners>
      </BannersProvider>
      <DesktopDraggableArea className={styles.root}>
        <Routes>
          <Route path="signup" element={<UniversalLoginSignup />} />
          <Route path="login" element={<UniversalLogin />} />
          <Route path="coupon/:couponId" element={<UniversalLoginCouponRoute />} />
          <Route path="auth/sso" element={<UniversalLoginSso />} />
          <Route path="auth/authorize" element={<UniversalLoginAuthorize />} />
          <Route path="*" element={<Navigate to="login" />} />
        </Routes>
      </DesktopDraggableArea>
      <UniversalLoginReauthenticateInfoModal />
    </>
  )
}

export default UniversalLoginRoute
